export enum PopupStateTypes {
	QuickSummary = 'quick-summary',
	Comments = 'comments',
	PageCatchup = 'page-catchup',
	AIPresentationGeneration = 'ai-presentation-generation',
	BulkIssueCreate = 'bulk-issue-create',
	Menu = 'menu',
}
